import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(misc)/talk-resources/fitc-2025/page.linaria.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Icons/IconBluesky.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Icons/IconColorMode.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Icons/IconRSS.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Icons/IconSearch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Icons/IconSpeaker.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Link/Link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default","ListItem"] */ "/vercel/path0/src/components/List/List.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/MaxWidthWrapper/MaxWidthWrapper.linaria.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Logo/Logo.linaria.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Sandbox/index.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/SiteFooter/Affirmation.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/SiteFooter/FooterLink.linaria.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/SiteFooter/FooterCategoryList.linaria.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/SiteFooter/FooterNewsletterForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/SiteFooter/IconLink.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/SiteFooter/SiteFooter.linaria.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/SiteFooter/FooterSwoops.linaria.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/SiteFooter/ExtraCloud.linaria.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/SiteFooter/FullFatSiteFooter.linaria.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/GlassyBackdrop/GlassyBackdrop.linaria.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/LayoutBasic/LayoutBasic.linaria.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Link/TextLink.linaria.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/SiteFooter/UpsideDownJosh.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/SiteHeader/SiteHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SkipNavTrigger","SkipNavTarget"] */ "/vercel/path0/src/components/SkipNav/SkipNav.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Spacer/Spacer.linaria.module.css");
